import { useEffect } from "react";
import { SITE } from "@/config/site";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const Seo = ({ title, description, path = "/", noindex = false, image = "" }) => {
  useEffect(() => {
    const url = SITE.siteUrl ? `${SITE.siteUrl.replace(/\/$/, "")}${path}` : "";
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
    if (url) setMeta("property", "og:url", url);
    setCanonical(url);
    const og = document.head.querySelector('meta[property="og:image"]');
    if (image) setMeta("property", "og:image", image);
    else if (og) og.remove();
  }, [title, description, path, noindex, image]);
  return null;
};
